import { Input, Spin, notification } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate, useParams } from "react-router-dom";
import AppRoutes from "../../common/routes";
import { _reset_password_with_token } from "../../common/axios_services";
import { ReactComponent as ArrowLeftIcon } from "../../assets/images/icons/arrow-left-circle.svg";

const ResetPasswordPage = () => {
  const Navigate = useNavigate();
  const { id, token } = useParams();
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 24, color: "#fff" }} spin />
  );
  const [errorMessage, setErrorMessage] = useState("");
  const [fetchingData, setFetchingData] = useState(false);

  const resetCheck = yup.object().shape({
    token: yup.string().required("Reset token is required"),
    newPassword: yup
      .string()
      .min(8, "Password must be at least 8 characters")
      .required("New password is required"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValue: {
      token: "",
      newPassword: "",
      confirmPassword: "",
    },
    resolver: yupResolver(resetCheck),
  });

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: "",
      description: message,
    });
  };

  useEffect(() => {
    if (token) {
      setValue("token", token);
    }
  }, [token, setValue]);

  const handleResetPassword = async (e) => {
    setErrorMessage("");
    setFetchingData(true);
    let { token, newPassword, confirmPassword } = e;
    const email = localStorage.getItem("email_address_for_reset");
    try {
      await _reset_password_with_token({
        email,
        otpCode: token,
        newPassword,
        confirmPassword,
      });
      openNotificationWithIcon("success", "Password reset successfully!");
      localStorage.removeItem("email_address_for_reset");
      Navigate(AppRoutes.signin);
    } catch (err) {
      setFetchingData(false);
      if (err.response) {
        setErrorMessage(err.response.data.message);
      } else {
        setErrorMessage(err.message);
      }
    }
  };

  return (
    <div className="signin-page verification_page">
      <div className="small-page-title contain">
        <div className="grid-flex">
          <div onClick={() => Navigate(-1)}>
            <ArrowLeftIcon />
          </div>
        </div>
      </div>
      <div className="contain auth-content">
        <div className="mt_3">
          <div className="auth-sect-div">
            <h3 className="auth-sect-title">Reset Your Password</h3>
            <p>Enter your new password below.</p>
          </div>
          <div className="error-block">
            {errorMessage.length ? (
              <p className="form-error">{errorMessage}</p>
            ) : (
              ""
            )}
          </div>
          <form onSubmit={handleSubmit(handleResetPassword)}>
            {/* Token Input */}
            <div className="form_group">
              <label htmlFor="token">Reset Token</label>
              <Controller
                name="token"
                control={control}
                render={({ field }) => (
                  <Input
                    name="token"
                    {...field}
                    id="token"
                    type="number"
                    inputMode="numeric"
                    style={{ height: "5rem" }}
                  />
                )}
              />
              {errors.token && (
                <p className="form-error">{errors.token.message}</p>
              )}
            </div>

            {/* New Password Input */}
            <div className="form_group">
              <label htmlFor="newPassword">New Password</label>
              <Controller
                name="newPassword"
                control={control}
                render={({ field }) => (
                  <Input.Password
                    name="newPassword"
                    {...field}
                    id="newPassword"
                    style={{ height: "5rem" }}
                  />
                )}
              />
              {errors.newPassword && (
                <p className="form-error">{errors.newPassword.message}</p>
              )}
            </div>

            {/* Confirm Password Input */}
            <div className="form_group">
              <label htmlFor="confirmPassword">Confirm New Password</label>
              <Controller
                name="confirmPassword"
                control={control}
                render={({ field }) => (
                  <Input.Password
                    name="confirmPassword"
                    {...field}
                    id="confirmPassword"
                    style={{ height: "5rem" }}
                  />
                )}
              />
              {errors.confirmPassword && (
                <p className="form-error">{errors.confirmPassword.message}</p>
              )}
            </div>

            <div className="welcome-buttons mt_20">
              <div className="welcome-buttons-content">
                <div>
                  {!fetchingData ? (
                    <button className="btn-primary">Reset Password</button>
                  ) : (
                    <button disabled className="btn-primary">
                      <Spin indicator={antIcon} />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
